import { useMantineTheme } from '@mantine/core';
import type { EdgeProps } from '@xyflow/react';
import { BaseEdge } from '@xyflow/react';
import { memo, useMemo } from 'react';
import { getLineageFlowBezierPath } from '../../utils/getLineageFlowBezierPath';
import type { LineageFlowEdge } from '../EntityEdge/EntityEdge.types';

export const ChildEdge = memo(
	({
		id,
		sourceX,
		sourceY,
		targetX,
		targetY,
		sourcePosition,
		targetPosition,
		markerEnd,
	}: EdgeProps<LineageFlowEdge>) => {
		const theme = useMantineTheme();

		const [edgePath] = getLineageFlowBezierPath({
			sourceX,
			sourceY,
			sourcePosition,
			targetX,
			targetY,
			targetPosition,
		});

		const style = useMemo(
			() => ({
				stroke: theme.other.getColor('border/emphasis/default'),
				strokeWidth: 1,
			}),
			[theme]
		);

		return (
			<BaseEdge id={id} path={edgePath} markerEnd={markerEnd} style={style} />
		);
	}
);
